import React from 'react';
import {useSelector} from 'react-redux';

import {selectIsSelectedDeviceConnected} from '@/state/selectors/device';
import {selectIsDeviceConnected} from '@/state/selectors/mw';
import {twx} from '@/utils/tailwindUtils';

import BatteryContainer from './Battery/BatteryContainer';
import ConnectionStatus from './ConnectionStatus/ConnectionStatus';
import RemainingSticksInfo from './RemainingSticksInfo/RemainingSticksInfo';

const DeviceMetrics = ({className}) => {
    const isDeviceConnected = useSelector(selectIsDeviceConnected);
    const isSelectedDeviceConnected = useSelector(selectIsSelectedDeviceConnected);

    return (
        isSelectedDeviceConnected && (
            <div className={twx('flex flex-col gap-2', className)}>
                {isDeviceConnected && (
                    <div className='flex items-center gap-1.5'>
                        <BatteryContainer />
                        <RemainingSticksInfo />
                    </div>
                )}
                <ConnectionStatus />
            </div>
        )
    );
};

export default DeviceMetrics;
